import PropTypes from "prop-types";
import PaymentPriceSummaryContainer from "app/pages/.shared/PriceSummary/PaymentPriceSummaryContainer";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { ALERT_TYPE, PAYMENT_METHODS } from "app/constants";
import { FormattedMessage, useIntl } from "react-intl";
import PaymentTermsInputContainer from "app/pages/Booking/Payment/PaymentTermsInput/PaymentTermsInputContainer";
import Button from "app/pages/.shared/form/Button";
import isEmpty from "lodash/isEmpty";
import Paragraphs from "app/pages/.shared/Paragraphs";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import useOnScreen from "app/pages/.shared/useOnScreen";

const PaymentCTASection = ({
	termsErrorList = [],
	termsField,
	brandDisplayName,
	shouldDisableButton,
	paymentType,
	cartAmount,
	rgpdMessagePayment,
	onClick,
	onPaymentTermsBlur = () => {},
}) => {
	const intl = useIntl();
	let paymentButtonLabel = <FormattedMessage id="payment.submit" />;

	const isNothingToPay = cartAmount === 0;

	if (isNothingToPay) {
		paymentButtonLabel = <FormattedMessage id="payment.submit.nothing.to.pay" />;
	} else if (
		paymentType === PAYMENT_METHODS.IDEAL ||
		paymentType === PAYMENT_METHODS.SOFORT ||
		paymentType === PAYMENT_METHODS.GIROPAY ||
		paymentType === PAYMENT_METHODS.POSTFINANCE_EFINANCE ||
		paymentType === PAYMENT_METHODS.POSTFINANCE_CARD ||
		paymentType === PAYMENT_METHODS.PAYPAL ||
		paymentType === PAYMENT_METHODS.PLEDG ||
		paymentType === PAYMENT_METHODS.ALMA
	) {
		paymentButtonLabel = (
			<FormattedMessage
				id="payment.external.submit.continue"
				values={{
					paymentPartner: intl.formatMessage({
						id: `payment.method.${paymentType}`,
					}),
				}}
			/>
		);
	} else if (paymentType === PAYMENT_METHODS.SWISS_BILLING) {
		paymentButtonLabel = <FormattedMessage id="payment.submit.only.validate" />;
	}

	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });

	useEffect(() => {
		if (isElementOnScreen) {
			track("payment_view_CTA");
		}
	}, [isElementOnScreen]);

	return (
		<>
			<PaymentPriceSummaryContainer />

			{termsErrorList.length > 0 && (
				<AlertMessage
					alertType={ALERT_TYPE.ERROR}
					message={<FormattedMessage id="error.payment.must.accept.terms" />}
				/>
			)}

			<div className="payment__terms">
				<PaymentTermsInputContainer
					onBlur={onPaymentTermsBlur}
					field={termsField}
					brandDisplayName={brandDisplayName}
				/>
			</div>

			<Button
				variant="primary"
				submit
				onClick={onClick}
				loading={shouldDisableButton}
				disabled={shouldDisableButton}
				data-testid="payment-button"
			>
				{paymentButtonLabel}
			</Button>
			<div className="payment__mandatory-label" ref={ref}>
				<FormattedMessage id="payment.mandatory.fields.label" />
			</div>

			{!isEmpty(rgpdMessagePayment) && (
				<div className="payment__personal-data-treatment-label">
					<Paragraphs paragraphs={rgpdMessagePayment} enableHTMLFormatting={true} />
				</div>
			)}
		</>
	);
};

PaymentCTASection.propTypes = {
	termsErrorList: PropTypes.array,
	termsField: PropTypes.string,
	brandDisplayName: PropTypes.string,
	shouldDisableButton: PropTypes.bool,
	paymentType: PropTypes.string,
	cartAmount: PropTypes.number,
	rgpdMessagePayment: PropTypes.array,
	onClick: PropTypes.func,
	onPaymentTermsBlur: PropTypes.func,
};

export default PaymentCTASection;
